<template>
  <div id="threeContainer" style="width: 100%; height: 50vh; max-height: 415px; display: block">
    <canvas></canvas>
  </div>
</template>

<script>
import * as Three from 'three'
import {ThreeMFLoader} from "three/examples/jsm/loaders/3MFLoader";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";

// import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils.js";



export default {



  name: "ModelVision",
  data() {
    return {
      camera: null,
      renderer: null,
      scene: null,
      mesh: null,
      ob: null
    }
  },
  props: ['threeMfSrc', 'cameraPosition'],
  methods: {
    init: function() {
      let container = document.getElementById('threeContainer');

      this.camera = new Three.PerspectiveCamera(70, 2, 0.1, 100);
      this.camera.position.z = this.cameraPosition.z;
      this.camera.position.x = this.cameraPosition.x;
      this.camera.position.y = this.cameraPosition.y;



      this.scene = new Three.Scene();
      // const axesHelper = new Three.AxesHelper( 5 );
      // this.scene.add( axesHelper );

      const light = new Three.AmbientLight( 0x404040, 0.3 ); // soft white light
      this.scene.add( light );


      const camLight = new Three.DirectionalLight( 0xffffff, 1 );
      camLight.target.x = 0
      camLight.target.y = 0
      camLight.target.z = 0
      camLight.position.z = 0.5;
      camLight.position.x = 0.5;
      camLight.position.y = 0.5;
      this.scene.add( camLight );

      const backLight = new Three.DirectionalLight( 0xffffff, 1 );
      backLight.target.x = 0
      backLight.target.y = 0
      backLight.target.z = 0
      backLight.position.z = -0.5;
      backLight.position.x = -0.5;
      backLight.position.y = -0.5;
      this.scene.add( backLight );

      const loader = new ThreeMFLoader();
      loader.load(this.threeMfSrc,  (object) => {
        // object.computeBoundingBox();
        // object.computeVertexNormals();
        // console.log(object)
        // this.printType(object);
        // object.transparent = true;
        // object.opacity = 0.3;
        this.ob = object
        var temp2 = new Three.Box3().setFromObject( object ).getSize(new Three.Vector3())
        var faktor = (Math.max.apply(Math, [temp2.x, temp2.y, temp2.z])) / 0.8;
        object.scale.x = 1 / faktor;
        object.scale.y = 1 / faktor;
        object.scale.z = 1 / faktor;
        object.traverse(function (child) {
          if (child.material) {
            // console.log(child.material)
            child.material.flatShading = true
            child.material.emissive.r = 0.1
            child.material.emissive.g = 0.1
            child.material.emissive.b = 0.1
            child.material.shininess = 20
            if (child.material.opacity < 1) {
              child.material.transparent = true;
            }
            // alert(child.material.color.r + " " + child.material.color.g + " " + child.material.color.b)
            // alert((child.material.color.r === child.material.color.g && child.material.color.g === child.material.color.b) && child.material.color.b < 0.2)
            if ((child.material.color.r === child.material.color.g && child.material.color.g === child.material.color.b) && child.material.color.b < 0.3) {
              child.material.color.r = 0.3;
              child.material.color.g = 0.3;
              child.material.color.b = 0.3;
            }
            // if (child.children.length === 0) {
            //   // child.material.color.setStyle("#ffffff")
            //   // child.material.color.convertSRGBToLinear()
            //   // child.material.color.convertLinearToSRGB()
            // }
            // console.log(child.material)
            // console.log(child)
            // let m = child.material.color
            // let f = "rgb(" + Math.round(m.r * 255) + ", " + Math.round(m.g * 255) + ", " + Math.round(m.b * 255)+ ")"
            // if (f === "rgb(170, 170, 255)") {
            //   console.log(f)
            // }
          }
          if (child.type === "Mesh") {
            //
            // var center = new Three.Vector3();
            // child.geometry.computeBoundingBox();
            // child.geometry.boundingBox.getCenter(center);
            // child.geometry.center();
            // child.position.copy(center);
            // child.geometry.center();
            // var g = new Three.CylinderGeometry( 0.5, 0.5, 1, 30, 3 );
            // console.log(g)
            // g.computeAngleVertexNormals(1)
            //   var attrib = child.position;
            //   if(attrib === undefined) {
            //     throw new Error('a given BufferGeometry object must have a position attribute.');
            //   }
            //   var positions = [attrib.x, attrib.y, attrib.z];
            //   console.log(positions)
            //   var vertices = [];
            //   for(var i = 0, n = positions.length; i < n; i += 3) {
            //     var x = positions[i];
            //     var y = positions[i + 1];
            //     var z = positions[i + 2];
            //     vertices.push(new Three.Vector3(x, y, z));
            //   }
            //   var faces = [];
            //   for(var m = 0, g = vertices.length; m < g; m += 3) {
            //     // faces.push(new Three.Face3.create(i, i + 1, i + 2));
            //     faces.push(new Three.Vector3(m, m + 1, m + 2));
            //   }
            //
            //   var geometry = new Three.BufferGeometry();
            //   geometry.vertices = vertices;
            //   geometry.faces = faces;
            //   geometry.position = attrib
            //   geometry.computeFaceNormals();
            //   console.log(geometry)
            //   // geometry = BufferGeometryUtils.mergeVertices( geometry);
            //   // geometry.mergeVertices()
            //   geometry.computeVertexNormals();
            //
            //   ///////////////////////////////////////////////////////////////
            //   // child.geometry = new THREE.Mesh(geometry, child.material);
            //   var mesh = new Three.Mesh(geometry, child.material);
            //   child.geometry = mesh
            //   // this.scene.add( mesh );
            //
            //
            //   // child.geometry.mergeVertices(child.geometry)
            //   // child.geometry = BufferGeometryUtils.mergeVertices( child.geometry, 0.00001);
            //   // child.geometry.computeVertexNormals()
            //   // child.geometry.computeFaceNormals()
            //   // child.geometry = geo;
          }
        });



        // Objekt auf der Z-Achse zentrieren (gab iwie keine vernünftige standard-funktion dafür?!)
        var objDim = new Three.Box3().setFromObject( object )
        let width = (objDim.max.z < 0 ? objDim.max.z * -1 : objDim.max.z) + (objDim.min.z < 0 ? objDim.min.z * -1 : objDim.min.z)
        object.position.z = width / 2 - objDim.max.z

        this.scene.add(object)
        this.render()
      });

      this.renderer = new Three.WebGLRenderer({canvas: document.querySelector("canvas"), antialias: true});
      this.renderer.setClearColor( 0xf8f8f8 );
      container.appendChild(this.renderer.domElement);

      var controls = new OrbitControls( this.camera, this.renderer.domElement );
      controls.addEventListener( 'change', this.render );
      controls.target.set(0,0,0)
      controls.update();

      const resizeObserver = new ResizeObserver(this.resizeCanvasToDisplaySize);
      resizeObserver.observe(document.querySelector('#threeContainer'), {box: 'content-box'});
      // resizeObserver.observe(this.renderer.domElement, {box: 'content-box'});
    },
    render: function() {
      this.resizeCanvasToDisplaySize()
      this.renderer.render(this.scene, this.camera);
    },
    // printType(object) {
    //   if (object.type === "Mesh") {
    //     var geo = BufferGeometryUtils.mergeVertices( object.geometry);
    //     // Three.BufferGeometryUtils;
    //     geo.computeVertexNormals()
    //     object.geometry = geo;
    //   }
    //   for (let i = 0; i < object.children.length; i++) {
    //     this.printType(object.children[i])
    //   }
    // },
    resizeCanvasToDisplaySize: function() {
      // console.log("resize")
      const canvas = this.renderer.domElement;
      // look up the size the canvas is being displayed
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      // console.log("Client: " + width + " " + height + ", Canvas: " + canvas.width + " " + canvas.height)
      // adjust displayBuffer size to match
      if (canvas.width !== width || canvas.height !== height) {
        // you must pass false here or three.js sadly fights the browser
        this.renderer.setSize(width, height, false);
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        // update any render target sizes here
      }
      this.renderer.render(this.scene, this.camera);
    }
  },
  mounted() {
    this.init();
  }
}

</script>

<style scoped>
canvas {
  width: 100%;
  height: 100%;
}

</style>